import React from "react";

type SwitchProps = {
  value: string;
  children: React.ReactElement<CaseProps>[];
};

export const Switch: React.FC<SwitchProps> = ({ value, children }) => {
  let comp = children.find((child) => child.props.values.includes(value));
  return comp ? comp : null;
};

type CaseProps = {
  values: string[];
  component: React.ReactElement;
};

export const Case: React.FC<CaseProps> = ({ component }) => {
  return component;
};
